import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { appPath } from '../lib/appPaths';

export function UserAvatar({ className = '' }: { className?: string }) {
  const { user } = useAuth();
  const initial = (user?.displayName?.trim()?.[0] || user?.email?.[0] || 'U').toUpperCase();

  return (
    <Link
      to={appPath('/more')}
      aria-label="Profile and settings"
      className={`btn-press flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#00A3FF] to-[#0066FF] text-sm font-bold text-white shadow-[0_4px_16px_rgba(0,102,255,0.35)] ${className}`}
    >
      {initial}
    </Link>
  );
}
